(function(settings) {
    var templateUrl = (settings.templateUrl || '/assets/js/wnmodules/wnsurvey/');

    function surveyQuestion() {
		return {
			restrict: 'A',
			templateUrl: templateUrl+'wnsurvey-question.tpl.html?'+Date.now(),
			scope: { element:'<wnSurveyQuestion', answer:'=' },
			link: function(scope, elem, attrs) {
				var e = scope.element;
				scope.answer = scope.answer || {
					type: e.fieldType || e.questionType,
					questionId: e.questionId,
					value: '',
					extra: {}
				};

				if (e.settings.extra) {
					var extra = e.settings.extra;

					if (extra.comments)
						scope.answer.extra.comments = '';

					if (extra.else)
						scope.answer.extra.else = { checked: false, answer: '' };						
				}

				switch (e.questionType) {
					case 'checkbox':
						scope.checkboxAnswers = {};
						scope.formatAnswers = function() {
							var value = '',
								i = 0;
							
							if (e.settings.inputType === 'radio') {
								if (arguments[0] === 'extraElse')
									scope.answer.value = scope.answer.extra.else.answer;

								if (scope.answer.extra && scope.answer.extra.else) {
									scope.answer.extra.else.checked = scope.answer.extra.else.answer == scope.answer.value;
								}
								return;
							}

							angular.forEach(scope.checkboxAnswers, function(ans, key) {
								if (ans) {
									value += key+',';
									i++;
								}
							});
							
							if (scope.answer.extra.else && scope.answer.extra.else.checked) {
								i++;
								value += scope.answer.extra.else.answer+',';
							}
							
							if (value.slice(-1) === ',') {
								value = value.substring(0, value.length - 1);
							}
							
							scope.answer.value = value;
							
							if (scope.element.settings.limitSelections === true) {
								if (i === scope.element.settings.maximumSelections) {
									$(elem).find("input:checkbox:not(:checked)").attr('disabled', true);
								} else { 
									$(elem).find("input:checkbox:not(:checked)").removeAttr("disabled");
								}
							}
						};

						if (e.settings.inputType === 'radio')
							scope.answer.value = e.options[0];
					break;
					case 'textfield':
						if (e.fieldType === 'date') {
							var dateInput = $(elem).find('.survey-date'),
								datepickerSettings = angular.copy(_localeDates);
							
							datepickerSettings.firstDay = 1;
							datepickerSettings.dateFormat = 'dd.mm.yy';
							
							dateInput.datepicker(datepickerSettings);
						}
					break;
					case 'select':
						scope.answer.value = e.options[0];
					break;
					case 'linearscale':
						scope.getRange = getRange;
						scope.range = getRange(e.options);
						scope.answer.value = e.options[1];

						function getRange(options) {
							var range = [],
								start = options[0],
								end = options[1];
							
							for (var i=start;i <= end;i++) {
								range[i] = true;
							}

							return range;
						}
					break;
				}

				scope.displayRules = {
					normalItems: ['textfield','textarea','select'].indexOf(e.questionType) >= 0,
					textfieldNormal: e.questionType === 'textfield' && (e.fieldType === 'text' || e.fieldType === 'numeric'),
					textfieldDate: e.questionType === 'textfield' && e.fieldType === 'date',
					textarea: e.questionType === 'textarea',
					select: e.questionType === 'select',
					upload: e.questionType === 'upload',
					linearscale: e.questionType === 'linearscale',
					checkbox: e.questionType === 'checkbox' && e.settings.inputType !== 'radio',
					radio: e.questionType === 'checkbox' && e.settings.inputType === 'radio',
					radioElse: e.questionType === 'checkbox' && e.settings.extra && e.settings.extra.else && e.settings.extra.else.show && e.settings.inputType === 'radio',
					checkboxElse: e.questionType === 'checkbox' && e.settings.extra && e.settings.extra.else && e.settings.extra.else.show && e.settings.inputType !== 'radio',
					extraComments: e.settings.extra && e.settings.extra.comments && e.settings.extra.comments.show
				};
			}
		};
	}

    function surveyElement(common) {
		return {
			restrict: 'A',
			templateUrl: templateUrl+'wnsurvey-element.tpl.html?'+Date.now(),
			scope: { element:'<wnSurveyElement' },
			controller: function($scope, $sce) {
				$scope.openUrl = common.openUrl;
				$scope.trust = (string) => $sce.trustAsHtml(string);
			}
		};
	}

    function surveyUploadElement() {
        function Ctrl(scope, Upload) {    
            scope.loader = {
                show: false,
                progress: 0
            };
            
            scope.upload = function(files) {
                scope.loader.show = true;
                
                Upload.upload({
                    url: '?action=uploadfiles',
                    data: { files: files }
                }).then(function (resp) {
                    //console.log('Success', resp.config.data, 'Response:', resp.data);
                    scope.answer['value'] = resp.data;
                }, function (resp) {
                    //console.log('Error status: ' + resp.status);
                }, function (evt) {
                    var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
                    scope.loader.progress = progressPercentage;
                    //console.log('progress: ' + progressPercentage + '% ');
                });
            };
        }

		return {
			restrict: 'A',
			templateUrl: templateUrl+'wnsurvey-upload-element.tpl.html?'+Date.now(),
			scope: { element:'=wnSurveyUploadElement', answer:'=' },
			controller: ['$scope','Upload', Ctrl]
		};
	}

    function surveyContactDetailsElement(common) {
		return {
			restrict: 'A',
			templateUrl: templateUrl+'wnsurvey-contactdetails-element.tpl.html?'+Date.now(),
			scope: { element:'<wnSurveyContactDetailsElement', answer:'=', injectAnswerFunc: '&' }, //, injectAnswerFunc: '&'
			link: function(scope) {
				scope.answer = scope.answer || {
					type: 'contactDetails'
				};

				scope.answer['firstName'] = '';
				scope.answer['familyName'] = '';
				scope.answer['email'] = '';
				scope.answer['mailingList'] = scope.element.mailingList;
				scope.answer['allowMailingListAttachment'] = !!scope.element.askMailingListPermission || (!!scope.element.mailingList && !!scope.element.mailingList.length);

				scope.answer['consentGranted'] = false;
				
				scope.compare = function(value, target) {
					return scope.answer[target] == scope.answer[value];
				};

				scope.countries = false;

				if (typeof countries !== 'undefined') {
					var _countries = [];
					
					angular.forEach(countries, function(value, key) {
						_countries.push({ code: key, name: value });
					});
				
					scope.countries = _countries;
				}
				
				angular.forEach(scope.element.options, function(option, key) {
					if (option === 'address') {
						scope.answer['streetAddress'] = '';
						scope.answer['city'] = '';
						scope.answer['postalCode'] = '';
					} else if (option === 'gender') {
						scope.answer['gender'] = 'male';
					} else if (option === 'password') {
						scope.answer['password'] = '';
						scope.answer['repeatPassword'] = '';
					} else if (option === 'guardianCheck') {
						scope.answer['guardianName'] = '';
						scope.answer['guardianSSN'] = '';
					} else {
						scope.answer[option] = '';
					}
				});

				if (typeof scope.injectAnswerFunc === 'function')
					scope.injectAnswerFunc();

			},
			controller: function($scope, $sce) {
				$scope.openUrl = common.openUrl;

				if ($scope.element.options.indexOf('guardianCheck') > -1) {
					$scope.$watch('answer', function(n,o) {
						if (n.dateOfBirth && n.dateOfBirth !== o.dateOfBirth) {
							const dobMoment = moment(n.dateOfBirth, "DD.MM.YYYY");
							const age = moment().diff(dobMoment, 'years');

							$scope.$evalAsync(() => {
								if (age < 18)
									$scope.element.options.push('guardianShow');							
								else {
									const guardianIndex = $scope.element.options.indexOf('guardianShow');

									if (guardianIndex > -1)
										$scope.element.options.splice(guardianIndex, 1);
								}
							});
						}						
					}, true);
				}

			}
		};
	}

    function surveyConditionalarea() {
		function Ctrl(scope, SurveyService) {
            scope.validateConditions = SurveyService.validateConditions;
			scope.$emit('wnsurvey.resize');
        }
        
        return {
			restrict: 'A',
			templateUrl: templateUrl+'wnsurvey-conditionalarea.tpl.html?'+Date.now(),
			scope: { element:'<wnSurveyConditionalarea', answers:'=' },
			controller: ['$scope','SurveyService', Ctrl]
		};
	}

	function bindHrefCompile($compile, $sce) {
		return { //Replace all href="URL" with ng-click="openUrl('URL')"
			restrict: 'A',
			link: function (scope, element, attrs) {
				scope.$watch(attrs.bindHrefCompile, (value) => {					
					const htmlValue = value.replace(/href="(.*?)"/g, (match, url) => 'ng-click="openUrl(\'' + url + '\')"');
					const trustedHtml = $sce.trustAsHtml(htmlValue);

					scope.$evalAsync(() => { //Compile, so that ng-click starts working
						$compile(element.html($sce.valueOf(trustedHtml)).contents())(scope);
					});
				});
			}
		};
	}
    
    angular.module('wisenetwork.survey.elements', ['wisenetwork.survey.service','ngSanitize','wisenetwork.common','ngFileUpload'])
	.directive('wnSurveyQuestion', surveyQuestion)
	.directive('wnSurveyElement', ['common', surveyElement])
	.directive('wnSurveyUploadElement', surveyUploadElement)
	.directive('wnSurveyContactDetailsElement', ['common', surveyContactDetailsElement])	
	.directive('bindHrefCompile', ['$compile', '$sce', bindHrefCompile])
	.directive('wnSurveyConditionalarea', surveyConditionalarea);
})(typeof wnSurveySettings !== 'undefined' ? wnSurveySettings : {})